var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('bannerSearch'),_c('knowledge',{attrs:{"id":"knowledge"}}),_c('study',{attrs:{"id":"study"}}),_c('hotNews',{attrs:{"id":"hotNews"}}),_c('resource',{attrs:{"id":"resource"}}),_c('ancientBooks',{attrs:{"id":"ancientBooks"}}),_c('customization',{attrs:{"id":"customization"}}),_c('homeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }